// extracted by mini-css-extract-plugin
export default {"formulaEditor":"formulaEditor___r82Ke","code":"code___BJi_k","active":"active___o_ECh"};